import React from 'react';
import { Background, Main, Text } from 'styles/themeColors';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import Banner from 'components/UI/Banner';
import Checkbox from 'components/UI/Checkbox';
import Button from 'components/UI/Button';
import Icon from 'view/Icon';
import { TEXT_LABELS } from 'constants/order';

interface Props {
  show: boolean;
  onRetry: () => void;
  onManualConfirm: (confirmed: boolean) => void;
  isManualConfirmed: boolean;
  setIsManualConfirmed: (confirmed: boolean) => void;
}

const StockApiErrorBanner: React.FC<Props> = ({
  show,
  onRetry,
  onManualConfirm,
  isManualConfirmed,
  setIsManualConfirmed
}) => {

  const handleCheckboxChange = (checked: boolean) => {
    setIsManualConfirmed(checked);
    onManualConfirm(checked);
  };

  if (!show) {
    return null;
  }

  const buttons = (
    <FlexboxContainer
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      gap='4px'
      width='100%'
    >
      <Checkbox
        id="manual-stock-confirm"
        checked={isManualConfirmed}
        onChange={handleCheckboxChange}
        label={TEXT_LABELS.STOCK_MANUAL_CONFIRM_LABEL}
        appearance="none"
        checkboxSize="s"
        theme={'black'}
        bgColor={Background.navy}
      />

      <Button
        borderColor={Background.navy}
        bgColor={Background.navy}
        onClick={onRetry}
      >
        <FlexboxContainer flexDirection="row" alignItems="center" gap="6px">
          {TEXT_LABELS.RETRY_BUTTON_TEXT}
        </FlexboxContainer>
      </Button>
    </FlexboxContainer>
  );

  return (
    <Banner
      bgColor={Main.warning}
      title={TEXT_LABELS.STOCK_API_ERROR_TITLE}
      text={TEXT_LABELS.STOCK_API_ERROR_TEXT}
      text1={TEXT_LABELS.STOCK_API_ERROR_TEXT1}
      text2={TEXT_LABELS.STOCK_API_ERROR_TEXT2}
      buttons={buttons}
    />
  );
};

export default StockApiErrorBanner;